var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckFilled = function SvgCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25Zm4.142 6.85-4.684 4.683a.618.618 0 0 1-.441.184.618.618 0 0 1-.442-.184l-2.708-2.708a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l2.267 2.266 4.241-4.241a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883Z",
    fill: "current"
  })));
};
export default SvgCheckFilled;